<!-- //SECTION - state-negotiation-CENTER -->
<div id="_state-negotiation-CENTER_" class="my-2 px-2 ism-white text-1.25 w-1/2 flex flex-col border overlay-dark-30">
  <div class="flex flex-row">Political Treaties and Negotiations</div>
</div>
